export default function download(data, filename) {
  import(/* webpackChunkName: "downloadjs" */ 'downloadjs').then(mod => {
    const func = mod.default
    func(data, filename)
  })
}
